import {IUserTicketPrize} from "../../firebase/topics/in-game-challenges/tickets-update/user-tickets-update-topic.model.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {InGameTicketPrizeType} from "./abstract/in-game-ticket-prize-types";
import {InGameTicketPrizeAbstract} from "./abstract/in-game-ticket-prize.abstract";

/**
 * https://evokeplc.atlassian.net/wiki/spaces/CRMSX/pages/542710740/Bonus+Types
 * 3rd party vouchers
 *
 * Same behavior as Freeplay Voucher, but this bonus can be used only with specific 3rd party companies which we integrate with their free play feature. 
 * Sometimes the bonus behaves a bit differently depends on the specific vendor integration.
 * 
 * a.k.a for us "{prizeValue} freeplay voucher"
 */
export class InGameTicketFreePlayVoucher3rdPartyPrize extends InGameTicketPrizeAbstract {
    constructor(protected _prizeData: IUserTicketPrize, private services: IServiceFactoryExtended) {
        if (InGameTicketPrizeType.ThirdPartyFreePlayVoucher !== _prizeData.prizeType) {
            throw new Error("Free Play Voucher 3rd Party cannot be given this prizeType" + _prizeData.prizeType);
        }
        super(_prizeData);
    }
    public prizeString() {
        // return this.services.translation.translate("IGC_FREE_PLAY_VOUCHER_PRIZE_TEMPLATE", {prizeValue: this._prizeData.prizeValue});
        return `${this._prizeData.prizeValue} freeplay voucher${this._prizeData.prizeValue>1 ? 's' : ''}`;
    }
}
